import config from '../config';
import selectedEnvironment from '../env';
import { formatDate_MM_YYYY } from '../Utils/FormatDate';
const API_URL = `${config[selectedEnvironment].API_URL}/ProfitAndLossReports`;

const ProfitAndLossDetails = async (
    caseId,
    accountantId,
    date,
    endDate,
    token,
    showNonParticipantItems = false,
    segmentationFilter = null,
    filterByDocumentDate = true,
    onlyProcessed = false,
    showItemsWithoutSortCodeGroup = false
) => {
    try {
        const body = {
            caseId,
            accountantId,
            date,
            endDate,
            showNonParticipantItems,
            filterByDocumentDate,
            onlyProcessed,
            showItemsWithoutSortCodeGroup,
            ...(segmentationFilter ?? {}),
        };
        const response = await fetch(`${API_URL}/SortCodeProfitAndLossDetails`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
    }
};

const ProfitAndLossDetailsYearly = async (
    caseId,
    accountantId,
    date,
    endDate,
    token,
    showNonParticipantItems = false,
    segmentationFilter = null,
    filterByDocumentDate = true,
    onlyProcessed = false,
    showItemsWithoutSortCodeGroup = false
) => {
    console.log('filterByDocumentDate', filterByDocumentDate);
    try {
        const body = {
            caseId,
            accountantId,
            date,
            endDate,
            showNonParticipantItems,
            filterByDocumentDate,
            onlyProcessed,
            showItemsWithoutSortCodeGroup,
            ...(segmentationFilter ?? {}),
        };
        const response = await fetch(`${API_URL}/SortCodeProfitAndLossDetailsByYear`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response;
    } catch (error) {
    }
};


const triggerProfitAndLossPdfDownload = (blob, caseId, date, endDate) => {
    const fileName = `${caseId}_${formatDate_MM_YYYY(date)}-${formatDate_MM_YYYY(endDate)}_דווח_רווח_הפסד.pdf`;
    const fileUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(fileUrl);
    return { blob, fileName };
};

const ProfitAndLossDetailsYearlyReport = async (
    caseId,
    accountantId,
    date,
    endDate,
    token,
    showPct,
    showNonParticipantItems = false,
    segmentationFilter = null,
    filterByDocumentDate = true,
    onlyProcessed = false,
    options = {}
) => {
    const { returnBlob = false, showItemsWithoutSortCodeGroup = false } = options;

    const response = await fetch(`${API_URL}/SortCodeProfitAndLossDetailsByYearReport`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            caseId,
            accountantId,
            date,
            endDate,
            showPct,
            showNonParticipantItems,
            filterByDocumentDate,
            onlyProcessed,
            showItemsWithoutSortCodeGroup,
            ...(segmentationFilter ?? {}),
        })
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const fileContent = await response.blob();
    const fileName = `${caseId}_${formatDate_MM_YYYY(date)}-${formatDate_MM_YYYY(endDate)}_דווח_רווח_הפסד.pdf`;

    if (returnBlob) {
        return { blob: fileContent, fileName };
    }

    return triggerProfitAndLossPdfDownload(fileContent, caseId, date, endDate);
};


const ProfitAndLossDetailsMonthlyReport = async (
    caseId,
    accountantId,
    date,
    endDate,
    token,
    showPct,
    showNonParticipantItems = false,
    segmentationFilter = null,
    filterByDocumentDate = true,
    showDetailedMonthlyBreakdown = false,
    selectedMonths = null,
    onlyProcessed = false,
    options = {}
) => {
    const { returnBlob = false, showItemsWithoutSortCodeGroup = false } = options;

    const response = await fetch(`${API_URL}/SortCodeProfitAndLossDetailsByMonthlyReport`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            caseId,
            accountantId,
            date,
            endDate,
            showPct,
            showNonParticipantItems,
            filterByDocumentDate,
            showDetailedMonthlyBreakdown,
            onlyProcessed,
            showItemsWithoutSortCodeGroup,
            ...(selectedMonths?.length ? { selectedMonths } : {}),
            ...(segmentationFilter ?? {}),
        })
    });


    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const fileContent = await response.blob();
    const fileName = `${caseId}_${formatDate_MM_YYYY(date)}-${formatDate_MM_YYYY(endDate)}_דווח_רווח_הפסד.pdf`;

    if (returnBlob) {
        return { blob: fileContent, fileName };
    }

    return triggerProfitAndLossPdfDownload(fileContent, caseId, date, endDate);
};

const toDate = (value) => {
    if (!value) {
        return null;
    }

    if (value instanceof Date) {
        return isNaN(value.getTime()) ? null : value;
    }

    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
};

const ProfitAndLossExcelReport = async (
    caseId,
    accountantId,
    date,
    endDate,
    token,
    showPct,
    isMonthly,
    showNonParticipantItems = false,
    segmentationFilter = null,
    filterByDocumentDate = true,
    onlyProcessed = false,
    showItemsWithoutSortCodeGroup = false,
    showDetailedMonthlyBreakdown = false,
    selectedMonths = null,
) => {
    const response = await fetch(`${API_URL}/SortCodeProfitAndLossExcelReport`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            caseId,
            accountantId,
            date,
            endDate,
            showPct,
            isMonthly,
            showNonParticipantItems,
            filterByDocumentDate,
            onlyProcessed,
            showItemsWithoutSortCodeGroup,
            ...(showDetailedMonthlyBreakdown ? { showDetailedMonthlyBreakdown: true } : {}),
            ...(selectedMonths?.length ? { selectedMonths } : {}),
            ...(segmentationFilter ?? {}),
        })
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const fileContent = await response.blob();
    const fileUrl = window.URL.createObjectURL(fileContent);

    const link = document.createElement('a');
    link.href = fileUrl;
    const startDateObj = toDate(date);
    const endDateObj = toDate(endDate);
    const extension = isMonthly
        ? `${startDateObj ? formatDate_MM_YYYY(startDateObj) : ''}-${endDateObj ? formatDate_MM_YYYY(endDateObj) : ''}`
        : `${startDateObj ? startDateObj.getFullYear() : ''}-${endDateObj ? endDateObj.getFullYear() : ''}`;
    link.setAttribute('download', `${caseId}_${extension}_דוח_רווח_הפסד.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};

const ProfitAndLossDetailsYearlyHtml = async (
    caseId,
    accountantId,
    date,
    endDate,
    token,
    showPct,
    showNonParticipantItems = false,
    filterByDocumentDate = true,
    onlyProcessed = false,
    showItemsWithoutSortCodeGroup = false
) => {
    const response = await fetch(`${API_URL}/SortCodeProfitAndLossDetailsByYearHtml`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            caseId,
            accountantId,
            date,
            endDate,
            showPct,
            showNonParticipantItems,
            filterByDocumentDate,
            onlyProcessed,
            showItemsWithoutSortCodeGroup,
        })
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.html;
};

const ProfitAndLossDetailsMonthlyHtml = async (
    caseId,
    accountantId,
    date,
    endDate,
    token,
    showPct,
    showNonParticipantItems = false,
    segmentationFilter = null,
    filterByDocumentDate = true,
    showDetailedMonthlyBreakdown = false,
    selectedMonths = null,
    onlyProcessed = false,
    showItemsWithoutSortCodeGroup = false
) => {
    const response = await fetch(`${API_URL}/SortCodeProfitAndLossDetailsByMonthlyHtml`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            caseId,
            accountantId,
            date,
            endDate,
            showPct,
            showNonParticipantItems,
            filterByDocumentDate,
            showDetailedMonthlyBreakdown,
            onlyProcessed,
            showItemsWithoutSortCodeGroup,
            ...(selectedMonths?.length ? { selectedMonths } : {}),
            ...(segmentationFilter ?? {}),
        })
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.html;
};

const GetMatchingProfitAndLossReports = async (
    caseId,
    accountantId,
    date,
    endDate,
    token,
    isFromProfitAndLossDetailed = null,
    filterByDocumentDate = false
) => {
    try {
        const requestBody = { caseId, accountantId, date, endDate, filterByDocumentDate };
        if (isFromProfitAndLossDetailed !== null) {
            requestBody.isFromProfitAndLossDetailed = isFromProfitAndLossDetailed;
        }
        const response = await fetch(`${API_URL}/GetMatchingProfitAndLossReports`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error getting matching profit and loss reports:', error);
        throw error;
    }
};

const SaveMatchingProfitAndLossReports = async (reports, token) => {
    try {
        const response = await fetch(`${API_URL}/SaveMatchingProfitAndLossReports`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ reports })
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
            throw new Error(`Failed to save reports: ${errorData.message || 'Unknown error'}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error saving matching profit and loss reports:', error);
        throw error;
    }
};

const DeleteMatchingProfitAndLossReport = async (id, token) => {
    try {
        const response = await fetch(`${API_URL}/DeleteMatchingProfitAndLossReport`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(id)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
            throw new Error(`Failed to delete report: ${errorData.message || 'Unknown error'}`);
        }

        return true;
    } catch (error) {
        console.error('Error deleting matching profit and loss report:', error);
        throw error;
    }
};

const GetYearlyProfitTotal = async (
    caseId,
    accountantId,
    date,
    endDate,
    token,
    isFromProfitAndLossDetailed = null,
    filterByDocumentDate = false
) => {
    try {
        const requestBody = { caseId, accountantId, date, endDate, filterByDocumentDate };
        if (isFromProfitAndLossDetailed !== null) {
            requestBody.isFromProfitAndLossDetailed = isFromProfitAndLossDetailed;
        }
        
        const response = await fetch(`${API_URL}/GetYearlyProfitTotal`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error getting yearly profit total:', error);
        throw error;
    }
};

const GetMatchingProfitAndLossReportData = async (caseId, accountantId, date, endDate, year, token, isFromProfitAndLossDetailed = null, profitAndLossTotalBalance = null) => {
    try {
        const requestBody = { caseId, accountantId, date, endDate };
        if (isFromProfitAndLossDetailed !== null) {
            requestBody.isFromProfitAndLossDetailed = isFromProfitAndLossDetailed;
        }
        if (profitAndLossTotalBalance !== null && profitAndLossTotalBalance !== undefined) {
            requestBody.profitAndLossTotalBalance = profitAndLossTotalBalance;
        }
        const response = await fetch(`${API_URL}/GetMatchingProfitAndLossReportData`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
            throw new Error(errorData.message || 'Failed to load matching profit and loss report data');
        }

        return response.json();
    } catch (error) {
        console.error('Error getting matching profit and loss report data:', error);
        throw error;
    }
};

const DownloadMatchingProfitAndLossReportPdf = async (caseId, accountantId, date, endDate, year, token, isFromProfitAndLossDetailed = null, profitAndLossTotalBalance = null) => {
    try {
        const requestBody = { caseId, accountantId, date, endDate };
        if (isFromProfitAndLossDetailed !== null) {
            requestBody.isFromProfitAndLossDetailed = isFromProfitAndLossDetailed;
        }
        if (profitAndLossTotalBalance !== null && profitAndLossTotalBalance !== undefined) {
            requestBody.profitAndLossTotalBalance = profitAndLossTotalBalance;
        }
        // Classic P&L / ledger matching PDF (no audit אישור רו״ח page).
        const response = await fetch(`${API_URL}/DownloadMatchingProfitAndLossReportPdf`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
            throw new Error(`Failed to download PDF: ${errorData.message || 'Unknown error'}`);
        }

        // Get the file content from the response
        const fileContent = await response.blob();

        // Create a URL for the file
        const fileUrl = window.URL.createObjectURL(fileContent);

        // Create a temporary link and trigger the download
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', `דוח_התאמה_לצורכי_מס_הכנסה_${caseId}_${year}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
    } catch (error) {
        console.error('Error downloading matching profit and loss report PDF:', error);
        throw error;
    }
};

/** Audit / financial-report pack: matching PDF with אישור רואה חשבון. */
const DownloadMatchingProfitAndLossReportPdfForAudit = async (
    caseId, accountantId, date, endDate, year, token,
    isFromProfitAndLossDetailed = null, profitAndLossTotalBalance = null,
) => {
    try {
        const requestBody = { caseId, accountantId, date, endDate };
        if (isFromProfitAndLossDetailed !== null) {
            requestBody.isFromProfitAndLossDetailed = isFromProfitAndLossDetailed;
        }
        if (profitAndLossTotalBalance !== null && profitAndLossTotalBalance !== undefined) {
            requestBody.profitAndLossTotalBalance = profitAndLossTotalBalance;
        }
        const response = await fetch(`${API_URL}/DownloadMatchingProfitAndLossReportPdfForAudit`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
            throw new Error(`Failed to download audit matching PDF: ${errorData.message || 'Unknown error'}`);
        }

        const fileContent = await response.blob();
        const fileUrl = window.URL.createObjectURL(fileContent);
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', `דוח_התאמה_לצורכי_מס_עם_אישור_${caseId}_${year}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
    } catch (error) {
        console.error('Error downloading audit matching profit and loss report PDF:', error);
        throw error;
    }
};

const GetSortCodeTotalByYear = async (caseId, accountantId, date, endDate, sortCodeId, token) => {
    try {
        const response = await fetch(`${API_URL}/GetSortCodeTotalByYear?sortCodeId=${encodeURIComponent(sortCodeId)}`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ caseId, accountantId, date, endDate })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error getting sort code total:', error);
        throw error;
    }
};

const GetAccountCardTotalByYear = async (caseId, accountantId, date, endDate, accountCardId, token) => {
    try {
        const response = await fetch(`${API_URL}/GetAccountCardTotalByYear?accountCardId=${encodeURIComponent(accountCardId)}`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ caseId, accountantId, date, endDate })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return { sortCodeTotal: data.accountCardTotal, year: data.year }; // Return in same format as SortCode for compatibility
    } catch (error) {
        console.error('Error getting account card total:', error);
        throw error;
    }
};

const GetProfitTotalFromTrialBalance = async (caseId, accountantId, date, endDate, token) => {
    try {
        const response = await fetch(`${API_URL}/GetProfitTotalFromTrialBalance`, {
            method: 'POST',
            headers: {
                "Authorization": 'Bearer ' + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ caseId, accountantId, date, endDate })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error getting profit total from trial balance:', error);
        throw error;
    }
};

const ProfitAndLossService = {

    ProfitAndLossDetails,
    ProfitAndLossDetailsYearly,
    ProfitAndLossDetailsYearlyReport,
    ProfitAndLossDetailsMonthlyReport,
    ProfitAndLossExcelReport,
    ProfitAndLossDetailsYearlyHtml,
    ProfitAndLossDetailsMonthlyHtml,
    GetMatchingProfitAndLossReports,
    SaveMatchingProfitAndLossReports,
    DeleteMatchingProfitAndLossReport,
    GetYearlyProfitTotal,
    DownloadMatchingProfitAndLossReportPdf,
    DownloadMatchingProfitAndLossReportPdfForAudit,
    GetMatchingProfitAndLossReportData,
    GetSortCodeTotalByYear,
    GetAccountCardTotalByYear,
    GetProfitTotalFromTrialBalance,

};

export default ProfitAndLossService;